// SVG asset URLs (Vite will fingerprint in prod). Works in dev & prod.
import asteroidPurpleUrl from './asteroid-purple.svg?url';
import asteroidBlueUrl from './asteroid-blue.svg?url';
import asteroidGreenUrl from './asteroid-green.svg?url';
import asteroidPinkUrl from './asteroid-pink.svg?url';
import asteroidSmallUrl from './asteroid-small.svg?url';
import asteroidLargeUrl from './asteroid-large.svg?url';

import oreIconPurpleUrl from './ore-icon-purple.svg?url';
import oreIconBlueUrl from './ore-icon-blue.svg?url';
import oreIconGreenUrl from './ore-icon-green.svg?url';
import oreIconPinkUrl from './ore-icon-pink.svg?url';
import oreIconCobaltUrl from './ore-icon-cobalt.svg?url';
import oreIconTitaniumUrl from './ore-icon-titanium.svg?url';

import coinIconUrl from './coin-icon.svg?url';
import energyIconUrl from './energy-icon.svg?url';
import productionIconUrl from './production-icon.svg?url';
import arrowRightUrl from './arrow-right.svg?url';

import crack0Url from './crack-0.svg?url';
import crack1Url from './crack-1.svg?url';
import crack2Url from './crack-2.svg?url';
import crack3Url from './crack-3.svg?url';
import crack4Url from './crack-4.svg?url';
import crack5Url from './crack-5.svg?url';
import crack6Url from './crack-6.svg?url';
import crack7Url from './crack-7.svg?url';
import crack8Url from './crack-8.svg?url';
import crack9Url from './crack-9.svg?url';

export const ASTEROID_SVG_PATHS = {
  purple: asteroidPurpleUrl,
  blue: asteroidBlueUrl,
  green: asteroidGreenUrl,
  pink: asteroidPinkUrl,
  small: asteroidSmallUrl,
  large: asteroidLargeUrl,
} as const;

export const ORE_ICON_SVG_PATHS = {
  purple: oreIconPurpleUrl,
  blue: oreIconBlueUrl,
  green: oreIconGreenUrl,
  pink: oreIconPinkUrl,
  cobalt: oreIconCobaltUrl,
  titanium: oreIconTitaniumUrl,
} as const;

export const RESOURCE_ICON_SVG_PATHS = {
  coins: coinIconUrl,
  energy: energyIconUrl,
  neon_iron: oreIconBlueUrl, // reuse blue ore icon
  cobalt: oreIconCobaltUrl,
  titanium: oreIconTitaniumUrl,
} as const;

export const UI_ICON_SVG_PATHS = {
  production: productionIconUrl,
  arrow_right: arrowRightUrl,
} as const;

export const CRACK_SVG_PATHS = {
  0: crack0Url,
  1: crack1Url,
  2: crack2Url,
  3: crack3Url,
  4: crack4Url,
  5: crack5Url,
  6: crack6Url,
  7: crack7Url,
  8: crack8Url,
  9: crack9Url,
} as const;

export type AsteroidType = keyof typeof ASTEROID_SVG_PATHS;
export type OreIconType = keyof typeof ORE_ICON_SVG_PATHS;
export type ResourceIconType = keyof typeof RESOURCE_ICON_SVG_PATHS;
export type UIIconType = keyof typeof UI_ICON_SVG_PATHS;
export type CrackLevel = keyof typeof CRACK_SVG_PATHS;
